import { useState, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useAuthStore } from './store/useAuthStore'
import { I18nProvider } from './i18n'
import { LoadingScreen } from './components/LoadingScreen'
import { Layout } from './components/Layout'
import { LandingPage } from './pages/LandingPage'
import { HomePage } from './pages/HomePage'
import { LoginPage } from './pages/LoginPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { LogoutPage } from './pages/LogoutPage'
import { AccountPage } from './pages/AccountPage'
import { MyCodesPage } from './pages/MyCodesPage'
import { ImpressumPage } from './pages/ImpressumPage'
import { KontaktPage } from './pages/KontaktPage'
import { DatenschutzPage } from './pages/DatenschutzPage'

function AppInner() {
  const initialize = useAuthStore((s) => s.initialize)

  useEffect(() => {
    void initialize()
  }, [initialize])

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/create" element={<HomePage />} />
        <Route path="/login" element={<LoginPage initialTab="login" />} />
        <Route path="/register" element={<LoginPage initialTab="register" />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/my-codes" element={<MyCodesPage />} />
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/kontakt" element={<KontaktPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
      </Routes>
    </Layout>
  )
}

export function App() {
  const [loading, setLoading] = useState(true)

  if (loading) {
    return <LoadingScreen onDone={() => setLoading(false)} />
  }

  return (
    <I18nProvider>
      <AppInner />
    </I18nProvider>
  )
}
